import { Configuration, LogLevel } from "@azure/msal-browser";
import { createLocalUrl } from "../utils/Helpers";

const isDevelopment = process.env.NODE_ENV !== "production";

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.AAD_OUTLOOK_CLIENT_ID,
    redirectUri: createLocalUrl("auth.html"),
    postLogoutRedirectUri: createLocalUrl("auth.html"),
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: isDevelopment ? LogLevel.Verbose : LogLevel.Error,
      piiLoggingEnabled: false,
      loggerCallback: (level: LogLevel, message: string) => {
        if (isDevelopment) {
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
          }
        } else {
          if (level === LogLevel.Error) {
            console.error(message);
          }
        }
      },
    },
  },
};

// Default scopes to use in the fallback dialog.
export const defaultScopes = ["user.read"];